import { render } from "./SignUpConfirmAlert.vue?vue&type=template&id=3004a60f"
import script from "./SignUpConfirmAlert.vue?vue&type=script&lang=js"
export * from "./SignUpConfirmAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__